<template>
	<div id="app">
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</div>
</template>
<script>

import {
	removeToken,
	getToken,
} from '@/utils/auth'

// 用于标记会话是否存活的key
const SESSION_ALIVE_KEY = 'app_session_alive';

export default {
	name: 'App',
	created() {
		// 检查是否是新会话（关闭浏览器/标签后重新打开）
		// sessionStorage 在关闭浏览器/标签时会被清除，刷新时会保留
		const isSessionAlive = sessionStorage.getItem(SESSION_ALIVE_KEY) === 'true';
		
		if (!isSessionAlive) {
			// 新会话：说明是关闭浏览器/标签后重新打开的
			// 执行清理操作
			this.clearCacheAndCloseSocket();
		}
		
		// 设置会话存活标记
		sessionStorage.setItem(SESSION_ALIVE_KEY, 'true');
	},
	mounted() {
		// 如果已有token（页面刷新的情况），初始化WebSocket
		// 登录成功后的WebSocket初始化在 store/modules/user.js 中处理
		// 开发模式下不连接 WebSocket
		if (process.env.NODE_ENV !== 'development' && getToken()) {
			this.$socketPublic.dispatch('webSocketInit');
		}
	},
	beforeDestroy() {
		// 组件销毁时关闭 WebSocket（页面内导航时）
		// 注意：这不会在关闭浏览器/标签时触发
	},
	methods: {
		// 清理函数：清除缓存和关闭socket
		clearCacheAndCloseSocket() {
			// 关闭 WebSocket
			if (this.$socketPublic) {
				this.$socketPublic.dispatch('closeWebSocket');
			}
			// 清除 token
			removeToken();
		}
	}
}
</script>
<style>
body {
	/* -webkit-user-select: none;
		-moz-user-select: none;
		user-select: none;
		-ms-user-select: none; */
	margin: 0 !important;
}

@import url("@/assets/style/common.css");

::-webkit-scrollbar {
	-webkit-appearance: none;
	width: 6px;
	height: 6px;
}

::-webkit-scrollbar-track {
	background: rgba(0, 0, 0, 0.1);
	border-radius: 0;
}

::-webkit-scrollbar-thumb {
	cursor: pointer;
	border-radius: 5px;
	background: rgba(0, 0, 0, 0.15);
	transition: color 0.2s ease;
}

::-webkit-scrollbar-thumb:hover {
	background: rgba(0, 0, 0, 0.3);
}

::-moz-scrollbar {
	-webkit-appearance: none;
	width: 6px;
	height: 6px;
}

::-moz-scrollbar-track {
	background: rgba(0, 0, 0, 0.1);
	border-radius: 0;
}

::-moz-scrollbar-thumb {
	cursor: pointer;
	border-radius: 5px;
	background: rgba(0, 0, 0, 0.15);
	transition: color 0.2s ease;
}

::-moz-scrollbar-thumb:hover {
	background: rgba(0, 0, 0, 0.3);
}

.el-image-viewer__actions {
	bottom: 60px !important;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
	-webkit-appearance: none !important;
}

::v-deep input[type="number"] {
	-moz-appearance: textfield !important;
}

.el-input-number .el-input__inner::-webkit-outer-spin-button,
.el-input-number .el-input__inner::-webkit-inner-spin-button {
	-webkit-appearance: none;
	appearance: none;
	margin: 0;
}

::v-deep.el-input input::-webkit-outer-spin-button,
::v-deep.el-input input::-webkit-inner-spin-button {
	-webkit-appearance: none !important;
}

::v-deep.el-input input[type="number"] {
	-moz-appearance: textfield;
}

::v-deep.el-input .el-input__inner {
	line-height: 1px !important;
}

.el-input.is-disabled .el-input__inner,
.el-textarea.is-disabled .el-textarea__inner {
	color: #000 !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}

input[type="number"] {
	-moz-appearance: textfield;
}

.el-input input::-webkit-input-placeholder {
	color: #4e4c4c;
}

.el-input input::-moz-input-placeholder {
	color: #4e4c4c;
}

.el-input input::-ms-input-placeholder {
	color: #4e4c4c;
}

.el-textarea textarea::-webkit-input-placeholder {
	color: #4e4c4c;
}

.el-textarea textarea::-moz-input-placeholder {
	color: #4e4c4c;
}

.el-textarea textarea::-ms-input-placeholder {
	color: #4e4c4c;
}
</style>
<style lang="scss"></style>